<template>
  <div v-if="isLoading" class="d-flex flex-fill">
    <div class="text-center m-auto">
      <b-spinner variant="primary" style="width: 5rem; height: 5rem" />
    </div>
  </div>
  <div v-else-if="!isLoading && canSubmitForm" class="page__on-boarding">
    <div class="img__banner">
      <div class="img__banner-background">
        <div class="banner-top">
          <b-img class="img__banner-top" :src="require(`@/assets/on-boarding/img-left-top.png`)">
          </b-img>
          <div class="text__banner">
            <p>Welcome</p>
            <span>A few clicks before getting ready</span>
          </div>
        </div>
        <div class="banner-bottom">
          <b-img
            class="img__banner-bottom"
            :src="require(`@/assets/on-boarding/img-right-bottom.png`)"
          >
          </b-img>
        </div>
      </div>
    </div>
    <b-col class="container__on-boarding">
      <b-col class="form__on-boarding col-md-10 col-lg-8 col-xl-11 p-0 m-0">
        <FormNameOnboarding
          ref="form-name"
          :firstname="user.firstname"
          :lastname="user.lastname"
          :is-eligible-name="isEligibleName"
          @submit:name-on-borading="updateFormNameOnBoarding"
        />
        <FormJobStatusOnboarding
          ref="form-job-status"
          @submit:job-status="updateFormJobStatusOnBoarding"
        />
        <b-button variant="first" class="button__form-continue" @click.prevent="onSubmit">
          <b-spinner v-if="isSaving" small></b-spinner>
          <span v-else> Continue </span>
        </b-button>
      </b-col>
    </b-col>
  </div>
</template>

<script>
import FormNameOnboarding from './components/FormNameOnboarding.vue';
import FormJobStatusOnboarding from './components/FormJobStatusOnboarding.vue';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import User from '@/models/User';
import UserJobStatus from '@/models/UserJobStatus';
import ChangeRequest from '@/models/ChangeRequest';

export default {
  components: {
    FormNameOnboarding,
    FormJobStatusOnboarding
  },
  mixins: [userInfoMixin],
  data() {
    return {
      isSaving: false,
      isLoading: false,
      canSubmitForm: false,
      record: null,
      isEligibleName: {
        isEligible: false,
        canChangeDate: ''
      },
      onBoardingForm: {
        firstname: '',
        lastname: '',
        job_status: '',
        company: '',
        area_of_employment: null
      }
    };
  },

  created() {
    this.checkSubmitForm();

    this.checkIsEligible();
  },
  methods: {
    async fetchUserJobStatus() {
      const {
        response: { data }
      } = await UserJobStatus.api().find();

      if (data && data.length) {
        this.record = data.find((item) => item.user?.id === this.userId);
      }
    },

    async checkIsEligible() {
      const {
        response: { data }
      } = await ChangeRequest.api().isChangeNameAble();

      this.$set(this.isEligibleName, 'isEligible', data.eligible);
      this.$set(this.isEligibleName, 'canChangeDate', data.canChangeDate);
    },

    async checkSubmitForm() {
      this.isLoading = true;
      if (this.user && this.user.confirmed) {
        //เช็คว่า user นี้เคยกรอกข้อมูล onboarding ไปแล้วหรือยัง
        await this.fetchUserJobStatus();

        this.isLoading = false;

        if (this.record && this.user.is_onboarded) {
          //ถ้าเคยกรอกแล้วให้ไปหน้า explore
          this.canSubmitForm = false;
          const previousPath = localStorage.getItem('previousPath');
          if (previousPath) {
            localStorage.removeItem('previousPath');
            this.$router.push({ path: previousPath });
          } else {
            this.$router.push({ name: 'learning-unit' });
          }
        } else {
          //ถ้ายังไม่เคยกรอกให้เริ่มกรอกข้อมูล
          this.canSubmitForm = true;
        }
      }
    },
    updateFormNameOnBoarding(form) {
      this.$set(this.onBoardingForm, 'firstname', form.firstname);
      this.$set(this.onBoardingForm, 'lastname', form.lastname);
    },

    updateFormJobStatusOnBoarding(form) {
      this.$set(this.onBoardingForm, 'job_status', form.job_status);
      this.$set(this.onBoardingForm, 'company', form.company);
      this.$set(this.onBoardingForm, 'area_of_employment', form.area_of_employment);
    },

    async onSubmit() {
      this.isSaving = true;

      try {
        if (this.$refs['form-name'] && this.$refs['form-job-status']) {
          this.$refs['form-name'].onSubmitName();
          this.$refs['form-job-status'].onSubmitJobStatus();
        }

        // เช็ค error Name
        if (this.$refs['form-name'] && this.$refs['form-name'].$v.$anyError) {
          return this.$refs['form-name'].$v.$anyError;
        }

        // เช็ค error job Status
        if (
          this.$refs['form-job-status'] &&
          this.$refs['form-job-status'].$refs['form__job-working-professional'] &&
          this.$refs['form-job-status'].$refs['form__job-working-professional'].$v.$anyError
        ) {
          return this.$refs['form-job-status'].$refs['form__job-working-professional'].$v.$anyError;
        }

        // เช็ค user jobctstus อีกครั้งว่ามีข้อมูลหรือยัง
        await this.fetchUserJobStatus();

        // Update user and job status
        if (!this.record && !this.user.is_onboarded) {
          await this.updateUserAndJobStatus();

          this.$toast.success('Onboarding form was updated successfully');
        } else {
          this.$toast.error('Something went wrong');
        }

        const previousPath = localStorage.getItem('previousPath');
        if (previousPath) {
          localStorage.removeItem('previousPath');
          this.$router.push({ path: previousPath });
        } else {
          this.$router.push({ name: 'learning-unit' });
        }
      } catch (error) {
        this.$toast.error('Something went wrong, please try again later');
      } finally {
        this.isSaving = false;
      }
    },
    isChangedName() {
      if (this.isEligibleName.isEligible) {
        const { firstname, lastname } = this.onBoardingForm;
        const { firstname: oldFirstname, lastname: oldLastname } = this.user;

        return firstname !== oldFirstname || lastname !== oldLastname;
      }
      return false;
    },

    async updateUserAndJobStatus() {
      let userData = {
        area_of_employment: this.onBoardingForm.area_of_employment,
        is_onboarded: true
      };

      if (this.isEligibleName.isEligible && this.isChangedName()) {
        await ChangeRequest.api().changeName({
          firstname: this.onBoardingForm.firstname,
          lastname: this.onBoardingForm.lastname
        });
      }

      await User.api().updateUser(userData);

      UserJobStatus.api().create({
        user: this.userId,
        working_status: this.onBoardingForm.job_status,
        company: this.onBoardingForm.company,
        area_of_employment: this.onBoardingForm.area_of_employment
      });
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  height: 100dvh;
}

.page__on-boarding {
  height: 100vh;
  height: 100dvh;
  display: grid;
  grid-template-columns: max-content auto;
}

.img__banner {
  width: 584px;
  position: relative;
  border: none;
}

.img__banner-background {
  position: absolute;
  z-index: -2;
  background-image: url('../../assets/on-boarding/img-bg-big.png');
  background-size: cover;
  background-repeat: no-repeat;
  border: none !important;
  height: 100%;
  width: 100%;
}

.banner-top {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.banner-bottom {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.text__banner {
  position: absolute;
  z-index: 2;
  width: max-content;
  padding-left: 4rem;

  p {
    font-size: 3rem;
    font-weight: 700;
    color: #f8f9ff;
    margin: 0;
  }

  span {
    font-size: 1.5rem;
    color: #f8f9ff;
    text-align: right;
  }
}

@media (min-width: 1900px) {
  .container__on-boarding {
    width: 60%;
    padding: 0;
    margin-left: 10%;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1899px) {
  .container__on-boarding {
    width: 80%;
    padding: 0;
    margin: auto;
  }
}

@media (max-width: 1199px) {
  .page__on-boarding {
    height: max-content;
  }

  .page__on-boarding {
    grid-template-columns: 1fr;
  }

  .container__on-boarding {
    justify-content: center;
    padding: 2.5rem 0 !important;
  }

  .img__banner {
    width: 100%;
    height: 312px;
  }

  .img__banner-background {
    background-image: url('../../assets/on-boarding/img-bg-small.png');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
  }

  .banner-top {
    display: flex;
    align-items: flex-end;
  }

  .text__banner {
    padding: 0;
    position: relative;
  }

  .img__banner-top {
    width: 176px;
    height: 191.55px;
  }

  .img__banner-bottom {
    width: 220px;
    height: 144.9px;
  }

  .text__banner {
    p {
      font-size: 2rem;
    }

    span {
      font-size: 1rem;
    }
  }
}

@media (max-width: 767px) {
  .container__on-boarding {
    padding: 2.5rem 2rem !important;
  }
}

@media (max-width: 576px) {
  .banner-top {
    display: block;
  }

  .text__banner {
    padding-left: 2rem;
  }
}

@media (max-width: 575px) {
  .banner-bottom {
    display: none;
  }

  .text__banner {
    padding-left: 2rem;
  }
}

.container__on-boarding {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
}

.form__on-boarding {
  display: grid;
  gap: 2.5rem;
}

.button__form-continue {
  width: max-content;
}
</style>
